import { useShopConfig } from './useShopConfig';
export function usePreconnectLinks({ ga = false, gtm = false } = {}) {
    const { apolloConfig, usePolyfilling = false } = useShopConfig();
    // These links are used with every store
    const staticLinks = [
        usePolyfilling && {
            href: 'https://cdnjs.cloudflare.com',
            crossOrigin: null
        },
        (apolloConfig === null || apolloConfig === void 0 ? void 0 : apolloConfig.graphQLURI) && {
            href: apolloConfig === null || apolloConfig === void 0 ? void 0 : apolloConfig.graphQLURI,
            crossOrigin: null
        }
    ].filter(Boolean);
    // Only preconnect to these urls if Google Analytics is enabled
    const gaLinks = ga
        ? [
            'https://www.google-analytics.com',
            'https://www.google.com',
            'https://stats.g.doubleclick.net'
        ]
        : [];
    // Only preconnect to these if GTM is enabled
    const gtmLinks = gtm ? ['https://www.googletagmanager.com'] : [];
    return [
        ...staticLinks,
        ...gaLinks.concat(gtmLinks).map((href) => ({ href, crossOrigin: null }))
    ];
}
//# sourceMappingURL=usePreconnectLinks.js.map